import { useEffect, useContext } from 'react'
import { ConfigContext, SwapManageContext } from '@/utils/contextStatic'
import useContractSwapV2 from '@/hooks/useContract/useContractSwapV2'
import usePublicEthers from '@/hooks/usePublic/usePublicEthers'
import usePublicErc20 from '@/hooks/usePublic/usePublicErc20'
import { chainCoin } from '@/utils/addressStatic'
import BigNumber from 'bignumber.js'

/**
 * 设置按钮状态 1:授權A 2:加載中 3:确认 5:钱包未链接 6: 链不匹配 7:授权B
 * @param {String} inputValA         // 输入值A
 * @param {String} inputValB         // 输入值B
 * @param {String} handler           // 方法
 */

export default function useBtnSwapAddLiq (inputValA: string, inputValB:string, handler: any) {

  const { _inPutFormat } = usePublicEthers()

  const { poolInfo } = useContext(SwapManageContext)
  
  const { swapOperateContract } = useContractSwapV2()
  
  const { account, chainId } = useContext(ConfigContext)

  const { _getDecimals, _getApproveAmount } = usePublicErc20()

  const { chain_id, pair_token0, pair_token1 } = poolInfo
  
  // 钱包 -> 授权
  useEffect(() => {
    const initFun = async() => {
      if(account) {
        if(+chainId === chain_id) {
          let directionA:any = 0
          let directionB:any = 0
          if(+inputValA > 0 || +inputValB > 0) {
            const approveAmountA = await _getApproveAmount(pair_token0, swapOperateContract)
            const approveAmountB = await _getApproveAmount(pair_token1, swapOperateContract)
            const decimalA = pair_token0 === chainCoin ? 18 : await _getDecimals(pair_token0)
            const decimalB = pair_token1 === chainCoin ? 18 : await _getDecimals(pair_token1)
            directionA = new BigNumber(approveAmountA).minus(_inPutFormat(inputValA ? inputValA : '0', decimalA)).toFixed(0)
            directionB = new BigNumber(approveAmountB).minus(_inPutFormat(inputValB ? inputValB : '0', decimalB)).toFixed(0)
          }
          if(+directionA >= 0 && +directionB >= 0) {
            handler(3)
          } else {
            if(directionA < 0) {
              handler(1)
            } else {
              if(directionB < 0) handler(7)
            }
          }
        } else {
          handler(6)
        }
      } else {
        handler(5)
      }
    }
    initFun()
  },[inputValB, inputValA, poolInfo, account, chainId]) 
}